// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1C82U","inner":"Form_inner__3YNai","range":"Form_range__4Q569","name":"Form_name__12vJc","actions":"Form_actions__2sZrW"};